import React from "react"
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint'
import anime from 'animejs/lib/anime.es.js'
import shuffle from "lodash/shuffle";

import "./service-technologies.scss"

function ServiceTechnologies(props) {
    let logoContainerRef = null;

    function scrollIn() {
        const titleAnim = anime({
            targets: '.service-technologies-title',
            opacity: [0, 1],
            delay: 500,
            duration: 250,
            easing: 'linear'
        });

        const logosTimeline = anime.timeline({
            targets: '.service-technologies-elements-item',
            loop: true,
            delay: anime.stagger(500, { from: 'center' }),
            loopComplete: (anim) => {
                changeLogos();
            }
        });

        logosTimeline
            .add({
                scale: [0, 1],
                opacity: [0, 1],
                duration: 500,
                easing: 'linear',
                endDelay: 3000
            })
            .add({
                scale: [1, 0],
                opacity: [1, 0],
                duration: 500,
                easing: 'linear'
            });
    }

    function scrollOut() {
        anime.remove('.service-technologies-elements-item');
    }

    function changeLogos() {
        let logosShuffled = shuffle(props.elements)
        let items = document.querySelectorAll('.service-technologies-elements-item img');

        items.forEach((item, index) => {
            let newSrc = logosShuffled[index].logoSrc;
            item.src = newSrc;

        });
    }

    function renderLogos(elements) {
        let rawMarkup = "";
        let itemsNumber = 9;

        // if (typeof elements !== `undefined`) {
            // console.log('elements at renderLogos undefined');
            // elements = [{ id: 'NOT_SET', logoSrc: 'NOT_SET'}];
        // }

        if (typeof window !== `undefined`) { //to fix 'window undefined' on building process 
            if (window.matchMedia('(min-width: 1440px)').matches || (elements.length < itemsNumber)) {
                itemsNumber = elements.length;
            }
        }

        for (let i = 0; i < itemsNumber; i++) {
            if (typeof elements[i] !== `undefined`) { //to fix 'elements undefined' on building process
                rawMarkup +=
                    `<div class="service-technologies-elements-item" key=${elements[i].id}>
                    <picture class="service-technologies-elements-item-image">
                        <img src=${elements[i].logoSrc} />
                    </picture>
                </div>`;
            }
        }

        return rawMarkup;
    }

    return (
        <Waypoint onEnter={scrollIn} onLeave={scrollOut}>
            <section className="service-technologies-container">
                <div className="service-technologies-title-container">
                    <h2 className="service-technologies-title">{props.title}</h2>
                </div>
                <div
                    ref={(ref) => { logoContainerRef = ref }}
                    className="service-technologies-elements-container"
                    dangerouslySetInnerHTML={{ __html: renderLogos(props.elements) }}
                ></div>
            </section>
        </Waypoint>
    )
}

ServiceTechnologies.propTypes = {
    title: PropTypes.string,
    elements: PropTypes.array
}

ServiceTechnologies.defaultProps = {
    title: ``,
    elements: []
}

export default ServiceTechnologies

